/**
 * Browser crypto polyfill for packages that expect Node.js crypto module.
 * Used by bson for generating random bytes.
 */

export const randomBytes = (size: number): Uint8Array => {
  const bytes = new Uint8Array(size);
  crypto.getRandomValues(bytes);
  return bytes;
};

export default { randomBytes };
